import { useRecordContext } from "ra-core";
import { RecordField } from "@/components/admin/record-field";
import { ReferenceField } from "@/components/admin/reference-field";
import { Show } from "@/components/admin/show";
import { Card, CardContent } from "@/components/ui/card";

import { StatusBadge, TestBadge } from "../faromarket-shared/StatusBadge";

const LeadStatusField = () => {
  const record = useRecordContext();
  return <StatusBadge value={record?.status} kind="lead_status" />;
};

const LeadTemperatureField = () => {
  const record = useRecordContext();
  return <StatusBadge value={record?.temperature} kind="temperature" />;
};

const LeadEnvironmentField = () => {
  const record = useRecordContext();
  return <StatusBadge value={record?.environment} kind="environment" />;
};

const LeadTestField = () => {
  const record = useRecordContext();
  if (!record?.is_test) return <span className="text-muted-foreground">—</span>;
  return <TestBadge value={record.is_test} />;
};

export const LeadShow = () => (
  <Show>
    <Card>
      <CardContent className="grid gap-4 md:grid-cols-2">
        <RecordField source="status" label="resources.leads.fields.status">
          <LeadStatusField />
        </RecordField>
        <RecordField
          source="temperature"
          label="resources.leads.fields.temperature"
        >
          <LeadTemperatureField />
        </RecordField>
        <RecordField
          source="company_id"
          label="resources.leads.fields.company_id"
        >
          <ReferenceField
            source="company_id"
            reference="companies"
            link="show"
          />
        </RecordField>
        <RecordField
          source="contact_id"
          label="resources.leads.fields.contact_id"
        >
          <ReferenceField
            source="contact_id"
            reference="contacts"
            link="show"
          />
        </RecordField>
        <RecordField
          source="service_interest_id"
          label="resources.leads.fields.service_interest_id"
        >
          <ReferenceField
            source="service_interest_id"
            reference="service_interests"
            link={false}
          />
        </RecordField>
        <RecordField source="source" label="resources.leads.fields.source" />
        <RecordField
          source="environment"
          label="resources.leads.fields.environment"
        >
          <LeadEnvironmentField />
        </RecordField>
        <RecordField source="is_test" label="resources.leads.fields.is_test">
          <LeadTestField />
        </RecordField>
        <RecordField
          source="form_submission_id"
          label="resources.leads.fields.form_submission_id"
        >
          <ReferenceField
            source="form_submission_id"
            reference="form_submissions"
            link="show"
          />
        </RecordField>
        <RecordField
          source="deal_id"
          label="resources.leads.fields.deal_id"
        >
          <ReferenceField source="deal_id" reference="deals" link={false} />
        </RecordField>
        <RecordField
          source="main_pain"
          label="resources.leads.fields.main_pain"
          className="md:col-span-2"
        />
        <RecordField
          source="initial_message"
          label="resources.leads.fields.initial_message"
          className="md:col-span-2"
        />
        <RecordField
          source="created_at"
          label="resources.leads.fields.created_at"
        />
        <RecordField
          source="updated_at"
          label="resources.leads.fields.updated_at"
        />
      </CardContent>
    </Card>
  </Show>
);
